// Casa La Vie cart-page discount code applier (T&W-style "Use code" expander).
// Uses Shopify's storefront cart discount API: POST /cart/update.js with { discount }.
// On success, reloads the page so the cart re-renders with the applied discount.

(function () {
  const SUCCESS_KEY = 'clv:discount-applied';

  if (customElements.get('discount-code')) return;

  class DiscountCode extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('.js-discount-toggle');
      this.toggleIcon = this.querySelector('.js-discount-toggle-icon');
      this.form = this.querySelector('.js-discount-form');
      this.input = this.querySelector('.js-discount-input');
      this.applyBtn = this.querySelector('.js-discount-apply');
      this.errors = this.querySelector('.js-discount-errors');
      this.success = this.querySelector('.js-discount-success');

      this.toggle.addEventListener('click', () => this.toggleForm());
      this.applyBtn.addEventListener('click', () => this.applyCode());
      this.input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.applyCode();
        }
      });

      // Wire up Remove buttons on already-applied discount codes (rendered server-side).
      document.querySelectorAll('.js-discount-remove').forEach((btn) => {
        btn.addEventListener('click', (e) => this.removeCode(e.currentTarget.dataset.discountCode));
      });

      // Show success message if we just applied a code (and the page reloaded).
      try {
        const justApplied = sessionStorage.getItem(SUCCESS_KEY);
        if (justApplied) {
          sessionStorage.removeItem(SUCCESS_KEY);
          this.toggleForm(); // expand the form so the message is visible
          if (this.success) this.success.hidden = false;
        }
      } catch (_) {}
    }

    toggleForm() {
      const expanded = this.toggle.getAttribute('aria-expanded') === 'true';
      if (expanded) {
        this.form.hidden = true;
        this.toggle.setAttribute('aria-expanded', 'false');
        if (this.toggleIcon) this.toggleIcon.textContent = '+';
      } else {
        this.form.hidden = false;
        this.toggle.setAttribute('aria-expanded', 'true');
        if (this.toggleIcon) this.toggleIcon.textContent = '−';
        setTimeout(() => this.input.focus(), 0);
      }
    }

    async applyCode() {
      const code = (this.input.value || '').trim();
      if (!code) return;
      this.errors.hidden = true;
      this.applyBtn.disabled = true;
      const originalLabel = this.applyBtn.textContent;
      this.applyBtn.textContent = '…';

      try {
        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: code })
        });
        const data = await res.json().catch(() => ({}));

        if (!res.ok) {
          this.showError(data && data.description ? data.description : this.invalidMessage());
          return;
        }

        // Shopify returns the cart; check whether the discount actually applied.
        const codes = (data && data.discount_codes) || [];
        const matched = codes.find((d) => (d.code || '').toLowerCase() === code.toLowerCase());

        if (matched && matched.applicable === false) {
          this.showError(this.invalidMessage());
          return;
        }
        if (codes.length === 0 && (!data.cart_level_discount_applications || data.cart_level_discount_applications.length === 0)) {
          this.showError(this.invalidMessage());
          return;
        }

        // Success — store flag so we can show the success message after reload.
        try { sessionStorage.setItem(SUCCESS_KEY, code); } catch (_) {}
        window.location.reload();
      } catch (err) {
        console.error(err);
        this.showError(this.invalidMessage());
      } finally {
        this.applyBtn.disabled = false;
        this.applyBtn.textContent = originalLabel;
      }
    }

    async removeCode() {
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: '' })
        });
        window.location.reload();
      } catch (err) {
        console.error(err);
      }
    }

    invalidMessage() {
      return (
        (window.theme && theme.strings && theme.strings.discountCode && theme.strings.discountCode.invalid) ||
        'Discount code is not valid.'
      );
    }

    showError(msg) {
      this.errors.textContent = msg;
      this.errors.hidden = false;
    }
  }

  customElements.define('discount-code', DiscountCode);
})();
